<template>
  <tbody>
    <template v-if="data.length" v-for="(row, rowIndex) in data">      
         <tr>       
          <template v-for="(column, columnIndex) in columns" v-if="isShow(column.field)">
            <template v-if="column.visible">
              <template v-if="(isFieldShowDatesComparison(column.field) && datesComparisonEnabled)">
                <td v-bind:class="column.field" v-bind:style="{'min-width': column.width}">
                  <div>{{getFieldValue(row, column.field, getDateAIndex(row.node)) | format(column.format)}}</div>
                </td>
                <td v-bind:class="column.field" v-bind:style="{'min-width': column.width}">
                  <div>{{getFieldValue(row, column.field, getDateBIndex(row.node)) | format(column.format)}}</div>
                </td>
                <template v-if="column.isMetricValue">
                  <td v-bind:class="column.field" v-bind:style="{'min-width': column.width}">
                    <div>{{getChangeValueBetweenDates(row.node, column.field) | formatCustom('integer')}}</div>
                  </td>
                  <td v-bind:class="column.field" v-bind:style="{'min-width': column.width}">
                    <div>{{getChangePercentageValueBetweenDates(row.node, column.field) | formatCustom('percentage', 2, '%')}}</div>
                  </td>
                </template>
              </template>

              <template v-else>
                <td
                  v-bind:class="column.field"
                  v-bind:style="{'min-width': column.width}"
                >{{getFieldValue(row, column.field, getDateAIndex(row.node)) | format(column.format)}}</td>
              </template>
            </template>
          </template>
        </tr>      
    </template>


    <!-- SUMMARY -->
    <template  v-for="groupType in ['average', 'total']">      
         <tr class="tr-summary" v-if="reportSummaryData.length > 0">       
         <template v-for="(column, columnIndex) in columns" v-if="isShow(column.field)">
            <template v-if="column.visible">
              <template v-if="(isFieldShowDatesComparison(column.field) && datesComparisonEnabled)">
                <td 
                v-bind:class="column.field + ' summary-' + groupType + '-td'" 
                v-bind:style="{'min-width': column.width}"   
                v-if="! isSummaryFieldsEquals(reportSummaryData, column.field, getDateAIndex(reportSummaryData)) || groupType == 'average'"
                v-bind:rowspan="isSummaryFieldsEquals(reportSummaryData, column.field, getDateAIndex(reportSummaryData)) ?  2 : 1"
                >
                  <div>{{getFieldValue(reportSummaryData, column.field, getDateAIndex(reportSummaryData), groupType) | format(column.format)}}</div>
                </td>
                <td 
                  v-bind:class="column.field + ' summary-' + groupType + '-td'" 
                  v-bind:style="{'min-width': column.width}"
                  v-if="! isSummaryFieldsEquals(reportSummaryData, column.field, getDateBIndex(reportSummaryData)) || groupType == 'average'"
                  v-bind:rowspan="isSummaryFieldsEquals(reportSummaryData, column.field, getDateBIndex(reportSummaryData)) ?  2 : 1"
                >
                  <div>{{getFieldValue(reportSummaryData, column.field, getDateBIndex(reportSummaryData), groupType) | format(column.format)}}</div>
                </td>
                <template v-if="column.isMetricValue">
                  <td 
                    v-bind:class="column.field + ' summary-' + groupType + '-td'" 
                    v-bind:style="{'min-width': column.width}"
                    v-if="! isSummaryFieldsEquals(reportSummaryData, column.field, getDateAIndex(reportSummaryData)) || groupType == 'average'"
                    v-bind:rowspan="isSummaryFieldsEquals(reportSummaryData, column.field, getDateAIndex(reportSummaryData)) ?  2 : 1"
                  >
                    <div>{{getChangeValueBetweenDates(reportSummaryData, column.field, groupType) | formatCustom('integer')}}</div>
                  </td>
                  <td 
                    v-bind:class="column.field + ' summary-' + groupType + '-td'" 
                    v-bind:style="{'min-width': column.width}"
                    v-if="! isSummaryFieldsEquals(reportSummaryData, column.field, getDateAIndex(reportSummaryData)) || groupType == 'average'"
                    v-bind:rowspan="isSummaryFieldsEquals(reportSummaryData, column.field, getDateAIndex(reportSummaryData)) ?  2 : 1"
                  >
                    <div>{{getChangePercentageValueBetweenDates(reportSummaryData, column.field, groupType) | formatCustom('percentage', 2, '%')}}</div>
                  </td>
                </template>
              </template>

              <template v-else>
                <td
                  v-if="! isSummaryFieldsEquals(reportSummaryData, column.field, getDateAIndex(reportSummaryData)) || groupType == 'average'"
                  v-bind:rowspan="isSummaryFieldsEquals(reportSummaryData, column.field, getDateAIndex(reportSummaryData)) ?  2 : 1"
                  v-bind:class="column.field + ' summary-' + groupType + '-td'"
                  v-bind:style="{'min-width': column.width}"                  
                >{{getFieldValue(reportSummaryData, column.field, getDateAIndex(reportSummaryData), groupType) | format(column.format)}}</td>
              </template>
            </template>
          </template>
        </tr>      
    </template>

  </tbody>
</template>

<script>
import "@/style/reports/base_table_style.scss";

import moment from "moment";
import tableColumnViewMixin from "@/components/reports/mixins/tableColumnViewMixin";
import filterMixin from "@/components/mixins/filterMixin";
import fixTableMixin from "@/components/reports/mixins/fixTableMixin";
import datesComparisonTableMixin from "@/components/reports/mixins/datesComparisonTableMixin";
import sortTableMixin from "@/components/reports/mixins/sortTableMixin";
import { dateFormatDefault } from "@/helpers/format";

export default {
  name: "customTableTBodyTemplate",
  components: {},
  props: {
    data: {
      type: Array,
      required: true
    },
    reportSummaryData: {
      type: [Object, Array],
      required: false
    },
    columns: {
      type: Array,
      required: true
    },
    namespace: {
      type: String,
      required: true
    },
    hoveredColumns: {
      type: Object,
      required: false
    },
    defaultColumns: {
      type: Array,
      required: true
    },
    fixed: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  mixins: [
    tableColumnViewMixin,
    filterMixin,
    fixTableMixin,
    datesComparisonTableMixin,
    sortTableMixin
  ],
  data() {    
    return {
    };
  },
  computed: {},
  filters: {},
  methods: {   
    getRowId: function(rowIndex) {
      if (this.fixed) {
        return this.namespace + "FixedRowColumn" + rowIndex;
      } else {
        return this.namespace + "RowColumn" + rowIndex;
      }
    },
    getRowIdOppositeTable: function(rowIndex) {
      if (this.fixed) {
        return this.namespace + "RowColumn" + rowIndex;
      } else {
        return this.namespace + "FixedRowColumn" + rowIndex;
      }
    },
    isShow: function(columnName) {
      let condition =
        this.isColumnFixed(columnName) && this.isAnyFixedColumnsExist;

      if (this.fixed) {
        return condition;
      } else {
        return !condition;
      }
    },
    getFieldValue: function(
      dataRow,
      columnName,
      rangeIndex = null,
      groupType = null
    ) {

      let data  = dataRow;
      if( dataRow.hasOwnProperty('node') ) {
        data = dataRow.node;
      } 

      const columnNames = {
        hour: "hour",
        week: "week",
        year: "year",
        quarter: "quarter",
        month: "month",
        date: "date",
        partnersNames: "partnersNames"
      };

      let dateFormat = dateFormatDefault();

      let value = null;
      if( data[rangeIndex] !== undefined ) {
        if( groupType !== null ) {
          value = data[rangeIndex][groupType];
        } else {
          value = data[rangeIndex]
        }
        value = value[columnName] !== undefined ? value[columnName] : null;
      }

      if (value !== null) {
        switch (columnName) {
          case columnNames.hour:
            if (value === null) break;

            let value2 = value + 1;
            value = value < 10 ? "0" + value : value;
            value2 = value2 < 10 ? "0" + value2 : value2;
            value = value + ":00 - " + value2 + ":00";
            break;

          case columnNames.week:
            value =
              moment(value.start).format(dateFormat) +
              " - " +
              moment(value.end).format(dateFormat);
            break;

          case columnNames.quarter:
            value =
              moment(value.start).format("MMM") +
              " - " +
              moment(value.end).format("MMM") +
              " " +
              moment(value.end).format("YYYY");
            break;

          case columnNames.month:
            value = moment(value.start).format("MMM YYYY");
            break;

          case columnNames.date:
            value = moment(value, "YYYY-MM-DD").format(dateFormat);
            break;

          case columnNames.partnersNames:
            if( value && value.length > 0 ) {
              value = value.join(", ");
            } else {
              value = null;
            }
            break;
        }
      }

      if ( value === null && [ "total", "average"].indexOf(groupType) !== -1 ) {
        return "";
      }

      return value;
    },
    getChangeValueBetweenDates: function(data, columnField, group = null) {
        
        let valueA = this.getFieldValue(data, columnField, this.getDateAIndex(data), group);
        let valueB = this.getFieldValue(data, columnField, this.getDateBIndex(data), group);

        if (
            (valueA !== 'N/A' && valueA !== null)
            &&
            (valueB !== 'N/A' && valueB !== null)
        )
        {
            return (valueB - valueA);
        }

        return null;
    },
    getChangePercentageValueBetweenDates: function(data, columnField, group = null) {
        let valueA = this.getFieldValue(data, columnField, this.getDateAIndex(data), group);
        let valueB = this.getFieldValue(data, columnField, this.getDateBIndex(data), group);

        if (
            (valueA !== 'N/A' && valueA !== null)
            &&
            (valueB !== 'N/A' && valueB !== null)
            &&
            (valueB !== 0)
        )
        {
            if (valueB === valueA)
                return 0;

            return (((valueB - valueA) / valueB) * 100);
        }

        return null;
    },
    isSummaryFieldsEquals: function(dataRow, columnName, rangeIndex) {

      let averageValue = this.getFieldValue(dataRow, columnName, rangeIndex, "average")
      let totalValue   = this.getFieldValue(dataRow, columnName, rangeIndex, "total");

      if( averageValue === "" && totalValue === "" ) return false;
      return totalValue === averageValue;

    },
    closeDropDownMenu: function(index) {
      this.$set(this.showLinkDropDownMenu, index, false);
    },
    getTrStyleObject: function(rowIndex) {
      let styleObj = {};

      let rowRef = document.querySelector(
        "#" + this.getRowIdOppositeTable(rowIndex)
      );

      if (rowRef != undefined) {
        styleObj.height = rowRef.offsetHeight + "px";
      }

      return styleObj;
    },
    getColumnClasses(columnName, rowIndex) {
      return {
        //'hovered': this.isColumnHovered(columnName),
        //'alter': (this.isColumnHovered(columnName) && rowIndex % 2 === 0),
        //'hidden': (this.isColumnFixed(columnName) && this.isAnyFixedColumnsExist)
        //'hovered': this.hoveredColumns[columnName]
      };
    }
  }
};
</script>

<style lang="scss" scoped>
tbody > tr {
  text-align: left;

  &:hover {
    background: #f5f5f5;
  }

  & > * {
    font-size: 13px;
  }

  & > td {
    border-right: 1px solid #f3f3f3;
    padding: 5px;
  }

  & > td.hovered {
    background: #f5f5f5;

    &.alter {
      background: #eef1f4;
    }
  }

  & > td.hidden {
    display: none;
  }

  & > td:last-child {
    border: 0;
  }
}
</style>

<style lang="scss" scoped>
.table-field__link {
  text-decoration: none;
  color: #0051ff;
  display: flex;
  align-items: center;

  &:hover {
    text-decoration: underline;
  }

  .arrow-drop-down {
    text-decoration: none;
    display: inline-block;
    width: 1.5em;
    height: 1.5em;
    color: #fff;
    background-image: url("/static/img/icon-arrow-drop-down-blue.svg");
    background-repeat: no-repeat;
    background-position: center;
    flex-shrink: 0;
  }
}

tbody > tr {
  text-align: left;

  &:hover {
    background: #f5f5f5;
  }

  & > * {
    font-size: 13px;
  }

  & > td {
    border-right: 1px solid #f3f3f3;
    padding: 5px;
  }

  & > td.hovered {
    background: #f5f5f5;

    &.alter {
      background: #eef1f4;
    }
  }

  & > td.hidden {
    display: none;
  }

  & > td:last-child {
    border: 0;
  }
}

tbody > tr.tr-summary {
  font-weight: bolder;
  background-color: #f3f3f3;
}

.table > tbody > tr > td.summary-average-td:nth-child(1):before {
  content: "Average: ";
}

div.fixed-active
  table
  > tbody
  > tr
  > td.summary-average-td:nth-child(1):before {
  content: inherit;
}

.table > tbody > tr > td.summary-total-td:nth-child(1):before {
  content: "Total: ";
}

div.fixed-active table > tbody > tr > td.summary-total-td:nth-child(1):before {
  content: inherit;
}

.sticky-body-column {
  position: relative;
  display: table-cell;
  transition: 0.3s;
}

.sticky-body-column:nth-last-child {
  border-right: 3px solid #cecece;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
  opacity: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/reports/scrubRateHourlyReport/templates/customTableTBodyTemplate.vue